import { render, staticRenderFns } from "./ApprovalChip.vue?vue&type=template&id=e38a5338"
import script from "./ApprovalChip.vue?vue&type=script&setup=true&lang=ts"
export * from "./ApprovalChip.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports